import BaseResource from '@/app-core/lib/data/resource/BaseResource'

export default class OtpResource extends BaseResource {
  constructor(payload = {}) {
    super(payload)

    this.otp = payload.otp ?? ''
    this.email = payload.email ?? ''
    this.phone = payload.phone ?? ''
    this.prefix = payload.prefix ?? ''
    this.type = payload.type ?? ''
    this.time = payload.time ?? 60
  }

  /* PROPERTIES */

  /* METHODS */
}
